import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import SwipeSlider from '../SwipeSlider';
import SwipeSliderV2 from './SwipeSlider';
export default withFeatureBranch({
    paywall_updates: SwipeSliderV2,
})(SwipeSlider);
//# sourceMappingURL=index.js.map